function updateRegion() {
   var activities = [];
   var regions = [];

   
}